import { authenticatedFetch } from '../../api/request';

const getSubscriptionOptions = async (orgId: number) => {
    return authenticatedFetch(`/v5/orgs/${orgId}/subscriptions`);
};

export default getSubscriptionOptions;
